import {
  generateArraySchema,
  generateMediaUrlSchema,
  generateObjectSchema,
  generateRootObjectSchema,
  generateStringSchema,
  generateUrlSchema,
} from "components/cards/common/schema";
import {
  BaseAtomSpec,
  generateAtomContainerSchema,
} from "components/cards/atoms/BaseAtomSpec";
import {
  ImageParticleSpec,
  TextParticleSpec,
  ButtonParticleSpec,
} from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec(
  "Gallery Viewer B Card",
  generateRootObjectSchema({
    container: generateAtomContainerSchema({
      defaultValues: {
        width: "1520px",
        height: "568px",
        fillWidth: false,
        fillHeight: false,
      },
    }),
    photos: generateArraySchema(
      "Photos",
      "The list of photos to display.",
      generateObjectSchema("Photo", "A photo within the gallery.", {
        title: generateStringSchema(
          "Caption Title",
          "Caption title for the photo."
        ),
        source: generateUrlSchema("Image URL", "Upload via an image url."),
        sourceUpload: generateMediaUrlSchema(
          "OR Image File Upload",
          "Or choose to upload image file directly."
        ),
      })
    ),
    imageStyle: ImageParticleSpec.generateSchema(
      "The styling of photos",
      "The styling of photos.",
      {
        defaultValues: {
          sizing: "cover",
          fillWidth: true,
          fillHeight: true,
          maxWidth: "100%",
          maxHeight: "100%",
          container: { fillWidth: true, fillHeight: true },
        },
        uneditableFields: { source: true, icon: true },
      }
    ),
    captionTextStyle: TextParticleSpec.generateSchema(
      "Caption Text Styling",
      "Styling for the caption box text.",
      {
        defaultValues: {
          size: "1.5rem",
          weight: "900",
          transform: "uppercase",
          color: "#1D110C",
          align: "left",
          wrap: "wrap",
          lineClamp: 2,
          lineHeight: "1.05",
          autoFit: false,
          container: {
            background: { visible: true, color: "#F2D82C" },
            width: "14rem",
            height: "5rem",
            padding: "0.5rem 0.75rem 0.5rem 1rem",
            centerContentHorizontally: false,
          },
        },
        uneditableFields: { text: true },
      }
    ),
    indexTextStyle: TextParticleSpec.generateSchema(
      "Index Text Styling",
      "Styling for the index (e.g. 1/4).",
      {
        defaultValues: {
          size: "1.5rem",
          weight: "900",
          transform: "uppercase",
          color: "#1D110C",
          container: {
            background: { visible: true, color: "#FFFFFF" },
            width: "5rem",
            height: "5rem",
            padding: "0",
          },
        },
        uneditableFields: { text: true },
      }
    ),
    leftButton: ButtonParticleSpec.generateSchema(
      "Left Arrow Button",
      "Styling for the previous button.",
      {
        defaultValues: {
          showText: false,
          container: {
            width: "5rem",
            height: "5rem",
            background: { visible: true, color: "#F1F1F1" },
          },
          image: {
            icon: "yc_icon_chevron_left",
            iconColor: "#1D110C",
            container: { width: "1.5rem", height: "1.5rem" },
            fillWidth: true,
            fillHeight: true,
          },
        },
      }
    ),
    rightButton: ButtonParticleSpec.generateSchema(
      "Right Arrow Button",
      "Styling for the next button.",
      {
        defaultValues: {
          showText: false,
          container: {
            width: "5rem",
            height: "5rem",
            background: { visible: true, color: "#F2D82C" },
          },
          image: {
            icon: "yc_icon_chevron_right",
            iconColor: "#1D110C",
            container: { width: "1.5rem", height: "1.5rem" },
            fillWidth: true,
            fillHeight: true,
          },
        },
      }
    ),
    overlayPadding: generateStringSchema(
      "Overlay Padding",
      "Padding around the overlay controls.",
      {
        defaultValue: "0",
      }
    ),
    controlsGap: generateStringSchema(
      "Controls Gap",
      "Gap between index text and arrow buttons.",
      {
        defaultValue: "0",
      }
    ),
  })
);
